import api from './api';

export function sendToken(params){
    return api.get('/sms-auth', {params});
}

export function verifySmsCode(params){
    return api.get('/verify-sms-auth-code', {params});
}

export function saveSmsAuthNumber(params){
    return api.post('/save-sms-auth-number', {params});
}

export function updateSmsAuthDetails(params){
    return api.put('/update-sms-auth-number', params);
}